<div>
  <mat-card>
    <h2>Anmelden</h2>
    <form #loginForm id="loginForm" (ngSubmit)="onSubmit()">
      <p>
        <mat-form-field color="accent">
          <input matInput type="email" name="email" placeholder="E-Mail" [formControl]="emailFormControl"
                 required email />
          <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
            Geben Sie bitte eine gültige E-Mail-Adresse an.
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('required')">
            Die E-Mail-Adresse ist erforderlich.
          </mat-error>
          <mat-error *ngIf="emailFormControl.hasError('cred_found')">
            E-Mail oder Passwort falsch.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <mat-form-field color="accent">
          <input matInput
                 [type]="hidePW ? 'password' : 'text'"
                 name="password"
                 placeholder="Passwort"
                 [formControl]="passwordFormControl" required />
          <fa-icon class="show-pw" [icon]="['fas', (hidePW?'eye':'eye-slash')]"
                   #tooltip="matTooltip" (click)="hidePW = !hidePW" matTooltipPosition="above"
                   matTooltip="Passwort anzeigen">
          </fa-icon>
          <mat-error *ngIf="passwordFormControl.hasError('required')">
            Bitte geben Sie ein Passwort ein.
          </mat-error>
          <mat-error *ngIf="passwordFormControl.hasError('cred_found')">
            E-Mail oder Passwort falsch.
          </mat-error>
        </mat-form-field>
      </p>
      <p>
        <button mat-flat-button color="accent" type="submit">Anmelden</button>
        <a class="lost-pw" routerLink="/passwort-vergessen">Passwort vergessen?</a>
      </p>
    </form>
  </mat-card>

  <mat-card>
    <h3 class="center">Sie haben noch keinen Zugang?</h3>
    <button class="center" mat-stroked-button color="accent" routerLink="/registrieren">Jetzt Registieren</button>
  </mat-card>

</div>
